import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBfRdPa1dq-QeERR5LDv56C_m9JkPmuDZA",
  authDomain: "mrgoodwallpapers-4018d.firebaseapp.com",
  projectId: "mrgoodwallpapers-4018d",
  storageBucket: "mrgoodwallpapers-4018d.firebasestorage.app",
  messagingSenderId: "484627291985",
  appId: "1:484627291985:web:c1ec56416ff45394b0fd70"
};

const app = initializeApp(firebaseConfig);

// 🔥 Firestore
const db = getFirestore(app);

// 🔥 Storage
const storage = getStorage(app);

// 🔥 Auth
const auth = getAuth(app);

export { app, db, storage, auth };

// 🔥 Dodaj ovo na kraj
export default app;
